/* THE GLOAM (LS-293): a night moth, pale, the size of a hand. Eight frames of one wing-beat -- the wings lift
 * and drop on a sine, a row a frame, their trailing edge lengthening as they rise so the mass holds; the edge
 * flicks bright at the top of the beat and the antennae swing once a cycle. The body and its yellow eyes are
 * still, the way a moth hangs in the air. It comes out only after dusk, it is drawn to any light, and it burns.
 * Generated once from a small script (the shape is arithmetic) and kept as data like every other actor. */

export const gloam_0 = [
  '................',
  '.....o....o.....',
  '......o..o......',
  '.......oo.......',
  '.ooooooyyoooooo.',
  'oMMMMMMddMMMMMMo',
  'oMmwmmMddMmmwmMo',
  'oMMmmmMddMmmmMMo',
  '.ooMmmMddMmmMoo.',
  '..oMMmMddMmMMo..',
  '...ooMMddMMoo...',
  '.....oMddMo.....',
  '......oddo......',
  '.......oo.......',
  '................',
  '................',
];

export const gloam_1 = [
  '................',
  '.....o....o.....',
  '......o..o......',
  '.ooo...oo...ooo.',
  'oMMMoooyyoooMMMo',
  'oMmmMMMddMMMmmMo',
  'oMMwmmMddMmmwMMo',
  '.ooMmmMddMmmMoo.',
  '...oMmMddMmMo...',
  '..oMMmMddMmMMo..',
  '...ooMMddMMoo...',
  '.....oMddMo.....',
  '......oddo......',
  '.......oo.......',
  '................',
  '................',
];

export const gloam_2 = [
  '................',
  '.....o....o.....',
  '.oo...o..o...oo.',
  'oMMooo.oo.oooMMo',
  'oMmMMMoyyoMMMmMo',
  'oMMmmmMddMmmmMMo',
  '.oowmmMddMmmwoo.',
  '..oMMMMddMMMMo..',
  '...oooMddMooo...',
  '..oMMMMddMMMMo..',
  '...ooMMddMMoo...',
  '.....oMddMo.....',
  '......oddo......',
  '.......oo.......',
  '................',
  '................',
];

export const gloam_3 = [
  '................',
  '.o...o....o...o.',
  'oMooo.o..o.oooMo',
  'oMMMMo.oo.oMMMMo',
  'oMmmmMoyyoMmmmMo',
  '.oMmmmMddMmmmMo.',
  '..owMmMddMmMwo..',
  '...ooMMddMMoo...',
  '...oooMddMooo...',
  '..oMMMMddMMMMo..',
  '...ooMMddMMoo...',
  '.....oMddMo.....',
  '......oddo......',
  '.......oo.......',
  '................',
  '................',
];

export const gloam_4 = [
  '................',
  '.o....o..o....o.',
  'owooo.o..o.ooowo',
  'owwwwo.oo.owwwwo',
  'owmmmwoyyowmmmwo',
  '.owmmmwddwmmmwo.',
  '..oMwmwddwmwMo..',
  '...oowwddwwoo...',
  '.....owddwo.....',
  '...oowwddwwoo...',
  '..owwwwddwwwwo..',
  '...ooowddwooo...',
  '......oddo......',
  '.......oo.......',
  '................',
  '................',
];

export const gloam_5 = [
  '................',
  '......o..o......',
  '.oo...o..o...oo.',
  'owwooo.oo.ooowwo',
  'owmwwwoyyowwwmwo',
  'owwmmmwddwmmmwwo',
  '.ooMmmwddwmmMoo.',
  '..owwwwddwwwwo..',
  '...ooowddwooo...',
  '...oowwddwwoo...',
  '..owwwwddwwwwo..',
  '...ooowddwooo...',
  '......oddo......',
  '.......oo.......',
  '................',
  '................',
];

export const gloam_6 = [
  '................',
  '......o..o......',
  '......o..o......',
  '.ooo...oo...ooo.',
  'owwwoooyyooowwwo',
  'owmmwwwddwwwmmwo',
  'owwMmmwddwmmMwwo',
  '.oowmmwddwmmwoo.',
  '...owmwddwmwo...',
  '...oowwddwwoo...',
  '..owwwwddwwwwo..',
  '...ooowddwooo...',
  '......oddo......',
  '.......oo.......',
  '................',
  '................',
];

export const gloam_7 = [
  '................',
  '......o..o......',
  '......o..o......',
  '.......oo.......',
  '.ooooooyyoooooo.',
  'owwwwwwddwwwwwwo',
  'owmMmmwddwmmMmwo',
  'owwmmmwddwmmmwwo',
  '.oowwmwddwmwwoo.',
  '...oowwddwwoo...',
  '..owwwwddwwwwo..',
  '...ooowddwooo...',
  '......oddo......',
  '.......oo.......',
  '................',
  '................',
];
